export default __webpack_public_path__ + "static/media/tools.974bd8f0.svg";